import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import { initKeycloak, isAuthenticated, consumePendingRedirect } from './keycloak';

loadFonts()

const app = createApp(App).use(vuetify).use(router)

initKeycloak().finally(() => {
  app.mount('#app');

  const pendingRedirect = consumePendingRedirect()
  if (pendingRedirect && isAuthenticated() && router.currentRoute.value.path !== pendingRedirect) {
    router.replace(pendingRedirect)
  }
});

const savedTheme = localStorage.getItem('uqm-theme')
const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
  vuetify.theme.global.name.value = 'dark'
}